import { observer } from "mobx-react-lite";
import { FunctionComponent, useContext } from "react";

import { nameOfFactory } from "@libs/utils/name-of.utils.ts";
import { useCardFormLayoutContext } from "@ui-components/card-form-layout/context/CardFormLayoutHelperContext.ts";
import { CheckboxGroupField } from "@ui-components/form/CheckboxGroupField.tsx";

import {
  ClaimDischargeCardIds,
  ClaimDischargeSideRailLabels
} from "../../claim/components/ClaimFormEnums.ts";
import { ClaimCard } from "../../shared-components/ClaimCard.tsx";
import { DischargeContext } from "../context/DischargeContext.ts";
import { ClaimDischargeFormValues } from "../types/dischargeFormValues.type.ts";

export const ClaimMultipleClaimTypesSection: FunctionComponent = observer(
  () => {
    const { selectedMenuItemId } = useCardFormLayoutContext();
    const { disciplines } = useContext(DischargeContext);
    const nameOf = nameOfFactory<ClaimDischargeFormValues>();

    return (
      <ClaimCard
        id={ClaimDischargeCardIds.MultipleClaimTypes}
        heading={ClaimDischargeSideRailLabels.MultipleClaimTypes}
        iconName="Family"
        openOnRender={
          selectedMenuItemId === ClaimDischargeCardIds.MultipleClaimTypes
        }
      >
        <CheckboxGroupField
          label="Claim types to discharge"
          name={nameOf("businessRoles")}
          options={disciplines}
          required
        />
      </ClaimCard>
    );
  }
);
